export default __webpack_public_path__ + "static/media/cheque-en.4f75ab40.png";